var map = {
	"./aparthotelclub/ic_tag_view.png": 12339,
	"./beachful/ic_tag_view.png": 63181,
	"./castlepedia/ic_tag_view.png": 64408,
	"./cocktayl/ic_tag_view.png": 53311,
	"./ic_tag_view.png": 30546,
	"./luxresortclub/ic_tag_view.png": 51216,
	"./parkful/ic_tag_view.png": 77280,
	"./prefabworld/ic_tag_view.png": 2518,
	"./rooftopclub/ic_tag_view.png": 82210,
	"./spaclub/ic_tag_view.png": 52035,
	"./worldcasino/ic_tag_view.png": 35221,
	"./zoopedia/ic_tag_view.png": 60505
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25940;